import React from 'react';
import clsx from 'clsx';
import LandingContainer from './LandingContainer';

const LandingSection = ({ id, variant = 'white', size = 'default', className, children }) => (
  <section
    id={id}
    className={clsx(
      'landing-section',
      `landing-section--${variant}`,
      `landing-section--${size}`,
      className
    )}
  >
    <LandingContainer>{children}</LandingContainer>
  </section>
);

export default LandingSection;
